/* Task-review prompt bus (Workstream J). One tiny, dependency-free channel so ANY
   outcome dialog (consultation outcome, call log, ...) can raise the shared
   non-blocking "You still have N open task(s) for this customer" panel WITHOUT
   depending on it staying mounted: the dialog closes and its list reloads
   (possibly unmounting it) - the panel lives in AppShell (TaskReviewHost) and
   survives that. Nothing here blocks navigation. */
export const TASK_REVIEW_EVENT = "salesos:task-review";
export const TASK_REVIEW_CHANGED_EVENT = "salesos:task-review-changed";

/** Open the panel for a review payload ({review_id, tasks?, unresolved_count?, ...}). */
export const showTaskReview = (payload) => {
  if (typeof window === "undefined" || !payload) return false;
  window.dispatchEvent(new CustomEvent(TASK_REVIEW_EVENT, { detail: payload }));
  return true;
};

/** Called with an outcome endpoint's `task_review` field: opens the panel only when the
    backend says a (new / changed / reminder-due) prompt is warranted - a deduplicated
    repeat (show_prompt false) or a clean customer (no unresolved tasks) stays silent. */
export const maybeShowTaskReview = (taskReview) => {
  if (!taskReview || taskReview.show_prompt !== true || !(taskReview.unresolved_count > 0)) return false;
  return showTaskReview(taskReview);
};

export const subscribeTaskReview = (fn) => {
  const handler = (e) => fn(e.detail);
  window.addEventListener(TASK_REVIEW_EVENT, handler);
  return () => window.removeEventListener(TASK_REVIEW_EVENT, handler);
};

export const notifyTaskReviewChanged = () => {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(TASK_REVIEW_CHANGED_EVENT));
};

export const subscribeTaskReviewChanged = (fn) => {
  window.addEventListener(TASK_REVIEW_CHANGED_EVENT, fn);
  return () => window.removeEventListener(TASK_REVIEW_CHANGED_EVENT, fn);
};
